import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import Breadcrumb from "./Breadcrumb";

type User = {
  id: number;
  name: string;
  permissions: {
    showImage: boolean;
    showVideo?: boolean;
    showGallery?: boolean;
    showProduct?: boolean;
  };
};

const Permission: React.FC = () => {
  const [users, setUsers] = useState<User[]>([
    {
      id: 1,
      name: "John Doe",
      permissions: {
        showImage: true,
      },
    },
    {
      id: 2,
      name: "Jane Smith",
      permissions: {
        showImage: false,
      },
    },
    {
      id: 3,
      name: "Alice Johnson",
      permissions: {
        showImage: true,
      },
    },
  ]);

  const togglePermission = (
    userId: number,
    permissionType: keyof User["permissions"]
  ) => {
    setUsers((prev) =>
      prev.map((user) =>
        user.id === userId
          ? {
              ...user,
              permissions: {
                ...user.permissions,
                [permissionType]: !user.permissions[permissionType],
              },
            }
          : user
      )
    );
  };

  return (
    <>
      <Breadcrumb />
      <Alert className="text-center">Permission</Alert>
      <div className="permission-container">
        <table className="permission-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Show Image</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.name}</td>
                {Object.keys(user.permissions).map((permission) => (
                  <td key={permission}>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={
                          user.permissions[
                            permission as keyof User["permissions"]
                          ]
                        }
                        onChange={() =>
                          togglePermission(
                            user.id,
                            permission as keyof User["permissions"]
                          )
                        }
                      />
                      <span className="slider"></span>
                    </label>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Permission;

// import React, { useState } from "react";

// type User = {
//   id: number;
//   name: string;
//   hasPermission: boolean;
// };

// const Permission: React.FC = () => {
//   const [users, setUsers] = useState<User[]>([
//     { id: 1, name: "John Doe", hasPermission: true },
//     { id: 2, name: "Jane Smith", hasPermission: false },
//     { id: 3, name: "Alice Johnson", hasPermission: true },
//     { id: 4, name: "John don", hasPermission: true },
//     { id: 5, name: "Jane game", hasPermission: false },
//     { id: 6, name: "Alice fit", hasPermission: true },
//   ]);

//   const togglePermission = async (id: number) => {
//     setUsers((prev) =>
//       prev.map((user) =>
//         user.id === id ? { ...user, hasPermission: !user.hasPermission } : user
//       )
//     );

//     try {
//       // Make an API call
//       const response = await fetch(`/api/toggle-permission/${id}`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id }),
//       });
//       if (!response.ok) throw new Error("Failed to update permission");
//     } catch (error) {
//       console.error("Error updating permission:", error);

//       setUsers((prev) =>
//         prev.map((user) =>
//           user.id === id ? { ...user, hasPermission: !user.hasPermission } : user
//         )
//       );
//     }
//   };

//   return (
//     <div className="permission-container">
//       <table className="permission-table">
//         <thead>
//           <tr>
//             <th>Name</th>
//             <th>show Image </th>
//             <th>show vedio </th>
//             <th>show gallary </th>
//             <th>show product </th>
//           </tr>
//         </thead>
//         <tbody>
//           {users.map((user) => (
//             <tr key={user.id}>
//               <td>{user.name}</td>
//               <td>
//                 <label className="switch">
//                   <input
//                     type="checkbox"
//                     checked={user.hasPermission}
//                     onChange={() => togglePermission(user.id)}
//                   />
//                   <span className="slider"></span>
//                 </label>
//               </td>
//               <td>
//                 <label className="switch">
//                   <input
//                     type="checkbox"
//                     checked={user.hasPermission}
//                     onChange={() => togglePermission(user.id)}
//                   />
//                   <span className="slider"></span>
//                 </label>
//               </td>
//               <td>
//                 <label className="switch">
//                   <input
//                     type="checkbox"
//                     checked={user.hasPermission}
//                     onChange={() => togglePermission(user.id)}
//                   />
//                   <span className="slider"></span>
//                 </label>
//               </td>
//               <td>
//                 <label className="switch">
//                   <input
//                     type="checkbox"
//                     checked={user.hasPermission}
//                     onChange={() => togglePermission(user.id)}
//                   />
//                   <span className="slider"></span>
//                 </label>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default Permission;
